import { createReducer } from '@reduxjs/toolkit';
import {
  addDataChartsDiagnosticOneActionsAsync,
  queryDiagnosticAAction,
  setAnswerAction,
  queryFormDiagnosticBActionASync,
} from './LoadingActions';
import { defaultLoadingStateWithData } from '../sharedConfig/initialState';
import {
  setChartActionAsync,
  setLoadingChartAction,
  setIdActionAsync,
} from './DiagnosticoActions';
import {
  changeEndOfDiagnosticStateAction,
  changeIntermediateTextStateAction,
  changeIntroductionStateAction,
} from './NavigateActions';
import { setFormDataInputsDiagnosticB } from './DiagnosticoActions';
export const initialState = {
  indiceGrupoActual: 0,
  indicePreguntaActual: 0,
  dataChart: [],
  loadingChart: false,
  currentAnswer: '',
  queryDiagnosticA: defaultLoadingStateWithData,
  setAnswer: defaultLoadingStateWithData,
  addDataChartsDiagnosticOne: defaultLoadingStateWithData,
  chartCaptures: {},
  idQuestions: '',
  navigation: {
    showIntroduction: true,
    showIntermediateText: false,
    endOfDiagnostic: false,
  },
  queryFormDiagnosticBState: defaultLoadingStateWithData,
  formDataInputsDiagnosticB: {
    name: '',
    email: '',
    phone: '',
  },
};
export const DiagnosticoReducer = createReducer(initialState, (builder) => {
  const providers = {
    setAnswerAction,
    addDataChartsDiagnosticOneActionsAsync,
    setChartActionAsync,
    changeIntroductionStateAction,
    changeIntermediateTextStateAction,
    changeEndOfDiagnosticStateAction,
    queryDiagnosticAAction,
    setFormDataInputsDiagnosticB,
    setLoadingChartAction,
    queryFormDiagnosticBActionASync,
    setIdActionAsync,
  };

  Object.keys(providers).forEach((key) => {
    providers[key].setAllBuilder(builder);
  });
});
